__turbopack_context__.v({
  "className": "inter_tight_85ffa382-module__nOHoAG__className",
  "variable": "inter_tight_85ffa382-module__nOHoAG__variable",
});
